"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const mobx_react_1 = require("mobx-react");
const newClubAdoption_1 = require("modules/content/newClubAdoption");
const DashboardService_1 = __importDefault(require("modules/dashboard/DashboardService"));
const featureToggle_1 = require("modules/featureToggle");
const ContentMembershipBanner_1 = __importDefault(require("../../../../membershipBanner/ContentMembershipBanner"));
const mapStateToProps = (stores) => ({
    isMobile: stores.UiStore.isMobile,
    userId: stores.UserStore.marketplaceId,
    locale: stores.UserStore.locale,
    productId: stores.MembershipStore.productId,
    shouldShowMembershipBanner: stores.UserStore.shouldShowMembershipBanner,
    isNewClubTemplateExperimentEnabled: stores.FeatureToggleStore.featureToggles.get(featureToggle_1.FeatureToggles.EnableNewClubTemplateExperiment)
});
const CtaMembershipBanner = ({ isMobile, userId, locale, productId, shouldShowMembershipBanner, isNewClubTemplateExperimentEnabled }) => {
    const storageKey = `newClubAdoptionCtaClosed:${productId}`;
    const storageData = sessionStorage.getItem(storageKey);
    const [hotmartClubData, setHotmartClubData] = (0, react_1.useState)({});
    (0, react_1.useEffect)(() => {
        const fetchHotmartClubData = async () => {
            const data = await DashboardService_1.default.hasNewClub(productId);
            setHotmartClubData(data);
        };
        fetchHotmartClubData();
    }, [productId]);
    const hasNewClub = Boolean(hotmartClubData || !(0, isEmpty_1.default)(hotmartClubData));
    const showExperimentTemplate = () => isNewClubTemplateExperimentEnabled && locale === 'PT_BR' && !hasNewClub;
    if (!showExperimentTemplate() || storageData === 'true') {
        return null;
    }
    return showExperimentTemplate() ? ((0, jsx_runtime_1.jsx)(newClubAdoption_1.NewClubAdoptionCta, { isMobile: isMobile, userId: userId, productId: productId })) : (shouldShowMembershipBanner && (0, jsx_runtime_1.jsx)(ContentMembershipBanner_1.default, { className: "_mb-5" }));
};
exports.default = (0, mobx_react_1.inject)(mapStateToProps)(CtaMembershipBanner);
